import React, { FC } from 'react';
import { Link } from '@material-ui/core';

import { Group } from 'api';
import { Numeric } from 'components';
import { generateLink } from 'Links';

interface IProps {
  group: Group;
}

const MembersCell: FC<IProps> = ({ group }) => (
  <Link component={generateLink(`/group/${group.id}/members`)}>
    <Numeric value={group.follower_count} />
  </Link>
);

export default MembersCell;
